/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Facility } from '@app/settings/facilities/facilities.model';
import { FacilitiesFormComponent } from '@app/settings/facilities/facilities-form/facilities-form.component';

@Injectable({
  providedIn: 'root',
})
export class FacilitiesFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open Facility form
   * @param facility Dialog data
   */
  public open(facility: null | Facility = null) {
    const modal = this.modalService.open(FacilitiesFormComponent);
    modal.componentInstance.facility = facility;
    return modal.result;
  }
}
